import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { localStorageMethod } from 'src/common/config/FunctionHelper';
import { useAccessControl } from 'src/hooks/useAccessControl';

interface ProtectedRoutesProps {
  children: React.ReactNode;
}

/**
 * Route guard component.
 *
 * Delegates all access-control logic to `useAccessControl`.
 * This component is responsible only for:
 *   1. Running the one-time GSCType cleanup side-effect.
 *   2. Rendering nothing while Stripe data is loading.
 *   3. Redirecting the user when the guard dictates it.
 *   4. Rendering children when access is allowed.
 */
const ProtectedRoutes = ({ children }: ProtectedRoutesProps) => {
  const location = useLocation();
  const { isLoading, redirectTo } = useAccessControl(location.pathname);

  // Clear any stale GSC-type flag on every protected navigation.
  useEffect(() => {
    localStorageMethod('remove', 'GSCType');
  }, [location.pathname]);

  if (isLoading) return null;
  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
};

export default ProtectedRoutes;
